import React, { useState, useEffect } from 'react';
import axios from 'axios';
import StatsCard from './StatsCard';
import { useAuth } from '../../contexts/AuthContext';

const ProjectStats = ({ totalProjects }) => {
  const [topCountries, setTopCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchTopCountries = async () => {
      try {
        const response = await axios.get('/api/stats/projects/top-countries', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setTopCountries(response.data);
        setError(null);
      } catch (err) {
        console.error('Erreur lors de la récupération des pays les plus actifs:', err);
        setError('Erreur lors de la récupération des pays les plus actifs');
      } finally {
        setLoading(false);
      }
    };

    fetchTopCountries();
  }, [token]);

  return (
    <StatsCard title="Projets" loading={loading} error={error}>
      <div className="stats-numbers">
        <div className="stat-item">
          <span className="stat-label">Total des projets</span>
          <span className="stat-value">{totalProjects || 0}</span>
        </div>
      </div>
      {!loading && !error && topCountries.length > 0 && (
        <div className="top-countries">
          <h3>Pays les plus actifs</h3>
          <div className="top-countries-list">
            {topCountries.map((country, index) => (
              <div key={country.pays} className="top-country-item">
                <span className="country-rank">{index + 1}</span>
                <span className="country-name">{country.pays}</span>
                <span className="country-count">{country.nombre_projets}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </StatsCard>
  );
};

export default ProjectStats; 